import React from 'react';

import { createIcon } from '@chakra-ui/react';

import { EColor } from '../Theme';

export const LotOfCashIcon = createIcon({
  viewBox: '0 0 24 24',
  path: (
    <path
      clipRule="evenodd"
      d="M3 5C2.44772 5 2 5.44772 2 6V14C2 14.5523 2.44772 15 3 15V10C3 8.34315 4.34315 7 6 7H18V6C18 5.44772 17.5523 5 17 5H3ZM20 7V6C20 4.34315 18.6569 3 17 3H3C1.34315 3 0 4.34315 0 6V14C0 15.6569 1.34315 17 3 17V18C3 19.6569 4.34315 21 6 21H20C21.6569 21 23 19.6569 23 18V10C23 8.34315 21.6569 7 20 7ZM6 9C5.44772 9 5 9.44772 5 10V18C5 18.5523 5.44772 19 6 19H20C20.5523 19 21 18.5523 21 18V10C21 9.44772 20.5523 9 20 9H6ZM10 14C10 12.3431 11.3431 11 13 11C14.6569 11 16 12.3431 16 14C16 15.6569 14.6569 17 13 17C11.3431 17 10 15.6569 10 14ZM13 13C12.4477 13 12 13.4477 12 14C12 14.5523 12.4477 15 13 15C13.5523 15 14 14.5523 14 14C14 13.4477 13.5523 13 13 13ZM8.17897 13.2556C8.58948 13.6251 8.62275 14.2573 8.25329 14.6679L8.24329 14.679C7.87383 15.0895 7.24154 15.1228 6.83103 14.7533C6.42052 14.3838 6.38725 13.7515 6.75671 13.341L6.76671 13.3299C7.13617 12.9194 7.76846 12.8861 8.17897 13.2556ZM19.179 13.2556C19.5895 13.6251 19.6228 14.2573 19.2533 14.6679L19.2433 14.679C18.8738 15.0895 18.2415 15.1228 17.831 14.7533C17.4205 14.3838 17.3872 13.7515 17.7567 13.341L17.7667 13.3299C18.1362 12.9194 18.7685 12.8861 19.179 13.2556Z"
      fill={EColor.Black}
      fillRule="evenodd"
    />
  ),
});
